import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { WfApproveRequest } from 'src/app/_model/request/WfApproveRequest';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import {RequestService} from "../../_services/request.service";
import {Requests} from "../../_model/Requests";

@Component({
    selector: 'app-requestsApproveSelected',
    templateUrl: './requestsApproveSelected.component.html',
    styleUrls: ['./requestsApproveSelected.component.css'],
    standalone: true,
        imports: [
            MatDialogModule
        ]
})
export class RequestApproveSelected implements OnInit {
    request:WfApproveRequest=new WfApproveRequest();
    currentUser: User;
    constructor(public dialogRef: MatDialogRef<RequestApproveSelected>,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Requests[],
                private requestService: RequestService,
                private authService: AuthenticationService,
                private toastr: ToastrService) {
        this.currentUser = this.authService.currentUserValue;
    }

    ngOnInit() {
    }
    closeModal(){
        this.dialogRef.close();
    }
    requestsApproveSelected(){

        this.data.forEach(element => {
            this.request.employeeId = this.currentUser.employeeId;
            this.request.operationRecordId = element.id;
            this.request.operationTableName = 'REQUESTS';
            this.request.fileList=[];
            this.requestService.approveRequests(this.request).subscribe(result => {
                this.toastr.success('Onaylama işlemi başarılı', '');
                this.dialogRef.close();
            }, error => {
                this.toastr.error(error.error.msg, 'Hata');
                this.dialogRef.close();
            });
        });

    }
}
